/**
 * Всё, что клиент кладёт в localStorage. Список закрытый: код комнаты и флаг
 * возрастного гейта.
 *
 * Токена здесь нет намеренно, хотя переживать перезагрузку он обязан. В Mini App
 * повторный вход бесплатен — initData доступна при каждом открытии, обмен стоит
 * один запрос, — а токен в localStorage переживает выход из аккаунта и утекает
 * вместе с любой XSS (clown-back/docs/auth-flow.md). Возврат в партию после
 * перезагрузки обеспечивает код комнаты: сессия выпускается заново, hello несёт
 * полное состояние.
 */
const KEY_ROOM = 'clown.room';
const KEY_AGE = 'clown.age18';

function read(key: string): string | null {
  try {
    return globalThis.localStorage?.getItem(key) ?? null;
  } catch {
    return null; // приватный режим или запрет хранилища — не повод падать
  }
}

function write(key: string, value: string | null): void {
  try {
    if (value === null) globalThis.localStorage?.removeItem(key);
    else globalThis.localStorage?.setItem(key, value);
  } catch {
    // Не сохранилось — партия переживает потерю, приложение тоже.
  }
}

export const storage = {
  roomCode: (): string | null => read(KEY_ROOM),
  setRoomCode: (code: string | null): void => write(KEY_ROOM, code),
  ageVerified: (): boolean => read(KEY_AGE) === '1',
  setAgeVerified: (value: boolean): void => write(KEY_AGE, value ? '1' : null),
};
